import moment from 'moment'
import 'moment-timezone'

const systemToMomentTimezoneMapping = {
  'AUS Central Standard Time': 'Australia/Darwin',
  'AUS Eastern Standard Time': 'Australia/Sydney',
  'Afghanistan Standard Time': 'Asia/Kabul',
  'Alaskan Standard Time': 'America/Anchorage',
  'Aleutian Standard Time': 'America/Adak',
  'Altai Standard Time': 'Asia/Barnaul',
  'Arab Standard Time': 'Asia/Qatar',
  'Arabian Standard Time': 'Asia/Dubai',
  'Arabic Standard Time': 'Asia/Baghdad',
  'Argentina Standard Time': 'America/Buenos_Aires',
  'Astrakhan Standard Time': 'Europe/Astrakhan',
  'Atlantic Standard Time': 'Atlantic/Bermuda',
  'Aus Central W. Standard Time': 'Australia/Eucla',
  'Azerbaijan Standard Time': 'Asia/Baku',
  'Azores Standard Time': 'Atlantic/Azores',
  'Bahia Standard Time': 'America/Bahia',
  'Bangladesh Standard Time': 'Asia/Dhaka',
  'Belarus Standard Time': 'Europe/Minsk',
  'Bougainville Standard Time': 'Pacific/Bougainville',
  'Canada Central Standard Time': 'America/Regina',
  'Cape Verde Standard Time': 'Atlantic/Cape_Verde',
  'Caucasus Standard Time': 'Asia/Yerevan',
  'Cen. Australia Standard Time': 'Australia/Adelaide',
  'Central America Standard Time': 'America/Guatemala',
  'Central Asia Standard Time': 'Asia/Urumqi',
  'Central Brazilian Standard Time': 'America/Cuiaba',
  'Central Europe Standard Time': 'Europe/Budapest',
  'Central European Standard Time': 'Europe/Warsaw',
  'Central Pacific Standard Time': 'Pacific/Noumea',
  'Central Standard Time': 'America/Chicago',
  'Chatham Islands Standard Time': 'Pacific/Chatham',
  'China Standard Time': 'Asia/Shanghai',
  'Cuba Standard Time': 'America/Havana',
  'Dateline Standard Time': 'Etc/GMT+12',
  'E. Africa Standard Time': 'Africa/Nairobi',
  'E. Australia Standard Time': 'Australia/Brisbane',
  'E. Europe Standard Time': 'Europe/Chisinau',
  'E. South America Standard Time': 'America/Sao_Paulo',
  'Easter Island Standard Time': 'Pacific/Easter',
  'Eastern Standard Time': 'America/New_York',
  'Egypt Standard Time': 'Africa/Cairo',
  'Ekaterinburg Standard Time': 'Asia/Yekaterinburg',
  'FLE Standard Time': 'Europe/Kiev',
  'Fiji Standard Time': 'Pacific/Fiji',
  'GMT Standard Time': 'Europe/London',
  'GTB Standard Time': 'Europe/Athens',
  'Georgian Standard Time': 'Asia/Tbilisi',
  'Greenland Standard Time': 'America/Godthab',
  'Greenwich Standard Time': 'Atlantic/Reykjavik',
  'Haiti Standard Time': 'America/Port-au-Prince',
  'Hawaiian Standard Time': 'Pacific/Honolulu',
  'India Standard Time': 'Asia/Calcutta',
  'Iran Standard Time': 'Asia/Tehran',
  'Israel Standard Time': 'Asia/Jerusalem',
  'Jordan Standard Time': 'Asia/Amman',
  'Kaliningrad Standard Time': 'Europe/Kaliningrad',
  'Korea Standard Time': 'Asia/Seoul',
  'Libya Standard Time': 'Africa/Tripoli',
  'Line Islands Standard Time': 'Pacific/Kiritimati',
  'Lord Howe Standard Time': 'Australia/Lord_Howe',
  'Magadan Standard Time': 'Asia/Magadan',
  'Magallanes Standard Time': 'America/Punta_Arenas',
  'Marquesas Standard Time': 'Pacific/Marquesas',
  'Mauritius Standard Time': 'Indian/Mauritius',
  'Middle East Standard Time': 'Asia/Beirut',
  'Montevideo Standard Time': 'America/Montevideo',
  'Morocco Standard Time': 'Africa/Casablanca',
  'Mountain Standard Time': 'America/Denver',
  'Mountain Standard Time (Mexico)': 'America/Chihuahua',
  'Myanmar Standard Time': 'Asia/Rangoon',
  'N. Central Asia Standard Time': 'Asia/Novosibirsk',
  'Namibia Standard Time': 'Africa/Windhoek',
  'Nepal Standard Time': 'Asia/Katmandu',
  'New Zealand Standard Time': 'Pacific/Auckland',
  'Newfoundland Standard Time': 'America/St_Johns',
  'Norfolk Standard Time': 'Pacific/Norfolk',
  'North Asia East Standard Time': 'Asia/Irkutsk',
  'North Asia Standard Time': 'Asia/Krasnoyarsk',
  'North Korea Standard Time': 'Asia/Pyongyang',
  'Omsk Standard Time': 'Asia/Omsk',
  'Pacific SA Standard Time': 'America/Santiago',
  'Pacific Standard Time': 'America/Los_Angeles',
  'Pacific Standard Time (Mexico)': 'America/Tijuana',
  'Pakistan Standard Time': 'Asia/Karachi',
  'Paraguay Standard Time': 'America/Asuncion',
  'Romance Standard Time': 'Europe/Paris',
  'Russia Time Zone 10': 'Asia/Srednekolymsk',
  'Russia Time Zone 11': 'Asia/Kamchatka',
  'Russia Time Zone 3': 'Europe/Samara',
  'Russian Standard Time': 'Europe/Moscow',
  'SA Eastern Standard Time': 'America/Punta_Arenas',
  'SA Pacific Standard Time': 'America/Jamaica',
  'SA Western Standard Time': 'America/Puerto_Rico',
  'SE Asia Standard Time': 'Asia/Jakarta',
  'Saint Pierre Standard Time': 'America/Miquelon',
  'Sakhalin Standard Time': 'Asia/Sakhalin',
  'Samoa Standard Time': 'Pacific/Apia',
  'Singapore Standard Time': 'Asia/Singapore',
  'South Africa Standard Time': 'Africa/Johannesburg',
  'Sri Lanka Standard Time': 'Asia/Colombo',
  'Syria Standard Time': 'Asia/Damascus',
  'Taipei Standard Time': 'Asia/Taipei',
  'Tasmania Standard Time': 'Australia/Hobart',
  'Tocantins Standard Time': 'America/Araguaina',
  'Tokyo Standard Time': 'Asia/Tokyo',
  'Tomsk Standard Time': 'Asia/Tomsk',
  'Tonga Standard Time': 'Pacific/Tongatapu',
  'Transbaikal Standard Time': 'Asia/Chita',
  'Turkey Standard Time': 'Europe/Istanbul',
  'Turks And Caicos Standard Time': 'America/Grand_Turk',
  'US Eastern Standard Time': 'America/Indianapolis',
  'US Mountain Standard Time': 'America/Phoenix',
  'UTC': 'Etc/GMT',
  'UTC+12': 'Etc/GMT-12',
  'UTC-02': 'Etc/GMT+2',
  'UTC-08': 'Etc/GMT+8',
  'UTC-09': 'Etc/GMT+9',
  'UTC-11': 'Etc/GMT+11',
  'Ulaanbaatar Standard Time': 'Asia/Ulaanbaatar',
  'Venezuela Standard Time': 'America/Caracas',
  'Vladivostok Standard Time': 'Asia/Vladivostok',
  'W. Australia Standard Time': 'Australia/Perth',
  'W. Central Africa Standard Time': 'Africa/Lagos',
  'W. Europe Standard Time': 'Europe/Berlin',
  'W. Mongolia Standard Time': 'Asia/Hovd',
  'West Asia Standard Time': 'Indian/Maldives',
  'West Bank Standard Time': 'Asia/Hebron',
  'West Pacific Standard Time': 'Pacific/Guam',
  'Yakutsk Standard Time': 'Asia/Yakutsk',
  // Ids offered by timezones-list.js that were missing here
  'Central Standard Time (Mexico)': 'America/Mexico_City',
  'Eastern Standard Time (Mexico)': 'America/Cancun',
  'Mid-Atlantic Standard Time': 'Etc/GMT+2',
  'Sao Tome Standard Time': 'Africa/Sao_Tome',
  'Sudan Standard Time': 'Africa/Khartoum',
  'Saratov Standard Time': 'Europe/Saratov',
  'Volgograd Standard Time': 'Europe/Volgograd',
  'Qyzylorda Standard Time': 'Asia/Qyzylorda',
  'Kamchatka Standard Time': 'Asia/Kamchatka',
  'UTC+13': 'Etc/GMT-13'
}

// Formats a UTC instant in a Windows time zone id (the call logs' `timeZone`). An unknown id falls
// back to the browser's own zone rather than failing.
export function formatUtcInTimeZone(date, timeZoneId, formatString) {
  const standardTimeZoneId = systemToMomentTimezoneMapping[timeZoneId]
  const utcDate = moment.utc(date)

  return (standardTimeZoneId ? utcDate.tz(standardTimeZoneId) : utcDate.local()).format(formatString)
}

// US zones by their everyday names, which the browser would spell with daylight saving ("EDT" vs "EST")
const TIME_ZONE_ABBREVIATIONS = Object.freeze({
  'Eastern Standard Time': 'ET',
  'US Eastern Standard Time': 'ET',
  'Central Standard Time': 'CT',
  'Mountain Standard Time': 'MT',
  'US Mountain Standard Time': 'MST',
  'Pacific Standard Time': 'PT',
  'Alaskan Standard Time': 'AKT',
  'Hawaiian Standard Time': 'HST',
  'UTC': 'UTC'
})

// A short label for a Windows time zone id: "ET", "CT", "PT" for the US zones, otherwise the browser's short
// name for the zone right now ("GMT+2", "GMT+5:30"), or the id when the zone is unknown
export function timeZoneAbbreviation(timeZoneId) {
  if (TIME_ZONE_ABBREVIATIONS[timeZoneId]) {
    return TIME_ZONE_ABBREVIATIONS[timeZoneId]
  }

  const standardTimeZoneId = systemToMomentTimezoneMapping[timeZoneId]

  if (!standardTimeZoneId) {
    return timeZoneId || ''
  }

  try {
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: standardTimeZoneId, timeZoneName: 'short' }).formatToParts(new Date())

    return parts.find(part => part.type === 'timeZoneName').value
  } catch (error) {
    return timeZoneId
  }
}

// The current time in a Windows time zone id, as a browser-local moment with that zone's wall clock. Date range
// pickers hold wall-clock times that getDateRangeInTimeZone reads in the selected zone, so "today" must be this
// zone's today, not the browser's or UTC's. An unknown id falls back to the browser's own time.
export function nowInTimeZone(timeZoneId) {
  const standardTimeZoneId = systemToMomentTimezoneMapping[timeZoneId]

  if (!standardTimeZoneId) {
    return moment()
  }

  return moment(moment.tz(standardTimeZoneId).format('YYYY-MM-DDTHH:mm:ss'))
}

export function getDateRangeInTimeZone(timeRange, timeZoneId) {
  const standardTimeZoneId = systemToMomentTimezoneMapping[timeZoneId]
  // Time is sent in UTC
  // If user selects 3PM in PST(UTC-08:00): the time which would be sent is 15:00 - 08:00 = 07:00 
  const fromTime = moment.tz(moment(timeRange[0]).format('YYYY-MM-DD HH:mm:ss'), standardTimeZoneId).utc().format('YYYY-MM-DDTHH:mm:ss[Z]')
  const toTime = moment.tz(moment(timeRange[1]).format('YYYY-MM-DD HH:mm:ss'), standardTimeZoneId).utc().format('YYYY-MM-DDTHH:mm:ss[Z]')

  return { fromTime, toTime }
}